module.exports = __webpack_public_path__ + "img/everybody_01.ef073bff.png";